<div class="publishbulk-wrapper">
  <app-thumbnail-gallery
    [sourceCards]="cardsToSelect"
    [disabledCards]="getDisabledCards()"
    [galleryMode]="GALLERY_MODE.SELECTION"
    (cardClicked)="onCardSelected($event)"
    (cardPriceTagClicked)="onCardSelected($event)"
    class="low-margin-title last-slider">
  </app-thumbnail-gallery>
</div>
<div class="background-overlay dark-background-overscroll"></div>
